import React, { lazy } from "react";
import { PublicRoute } from "../../../core/presentation/navigation/types/route";

const orderRoutes = [
  {
    path: "/order-cancel",
    Component: lazy(() => import("../pages/Bids/CancelledOrders")),
    permission: ["re_bid:list_all"],
  },
  {
    path: "/orders",
    Component: lazy(() => import("../pages/OrderProcessing")),
    permission: ["bid_request:list_all", "bid_request:list", "bid_request:create", "bid_request:update", "bid_request:detail"],
  },
  {
    path: "/orders/create",
    Component: lazy(() => import("../components/createPageI/OrderProcessingMain")),
    permission: ["bid_request:create"],
  },
  {
    path: "/orders/create/csv",
    Component: lazy(() => import("../components/createPageI/RequestByExcel")),
    permission: ["bid_request:create"],
  },
  {
    path: "/orders/create/table",
    Component: lazy(() => import("../components/createPageI/OrderByTable")),
    permission: ["bid_request:create"],
  },
  {
    path: "/order/detail/:id",
    Component: lazy(() => import("../components/BIds/BidHistoryViewPostPayment")),
    permission: ["order:detail", "bid_request:detail"],
  },
  {
    path: "*",
    Component: lazy(() => import("../../../core/presentation/pages/NotFound")),
    permission: ["*"],
  },
  {
    path: "/orders/bid-requests",
    Component: lazy(() => import("../pages/Bids")),
    permission: ["bid_request:list_all"],
  },
  {
    path: "/orders/bid-requests/:id",
    Component: lazy(() => import("../pages/Bids/Bids")),
    permission: ["bid_request:detail", "order:detail"],
  },
  {
    path: "/orders/history/:id",
    Component: lazy(() => import("../components/BIds/BidHistoryView")),
    permission: ["bid_request:detail", "order:detail"],
  },
  {
    path: "/orders/bid-details/:id",
    Component: lazy(() => import("../../../fleet/presentation/components/OrderAndBids/OrderDetails")),
    permission: ["bid_request:detail"],
  },
  // {
  //   path: "/orders/details/:id",
  //   Component: lazy(
  //     () => import("../components/BIds/BidHistoryViewPostPayment")
  //   ),
  //   permission: ["order:detail", "order:detail"],
  // },
  {
    path: "/order",
    Component: lazy(() => import("../pages/Order/index")),
    permission: ["order:detail", "order:list_all", "order:list", "order:create"],
  },
  {
    path: "/order/details/:orderType/:orderId",
    Component: lazy(() => import("../pages/Order/OrderDetails")),
    permission: ["bid_request:detail", "order:detail"],
  },
  {
    path: "/orders/expired-request/:id",
    Component: lazy(() => import("../pages/ExpireRequest/index")),
    permission: ["bid_request:detail", "order:detail"],
  },
  {
    path: "/refund-request",
    Component: lazy(() => import("../pages/RefundRequest/index")),
    permission: ["refund_policy:list_all"],
  },
  {
    path: "/transaction-payment/payment-completed",
    Component: lazy(() => import("../../../core/presentation/pages/PaymentCompleted")),
    permission: ["*"],
  },
];

export default orderRoutes;
